// Layout.tsx
import Header from "../Header/Header";
import SidebarComponent from "../Siderbar/Sidebar";
import "./Layout.scss";
import FooterComponent from "../Footer/Footer";

import React from "react";
import TourComponent from "../TourComponent/TourComponent";

const Layout = ({ children }: any) => {
  return (
    <main className="main">
      <Header />
      <SidebarComponent />
      <div className="mainContent">{children}</div>
      <TourComponent />
      <FooterComponent />
    </main>
  );
};

export default Layout;
